import {useRoute} from '@react-navigation/native';
import ToastContext, {ToastContextType} from 'context/ToastContext';
import {useContext} from 'react';
import {ToastType} from 'ui-kits';
import {toastDuration} from 'constants/DefaultValues';

// how that can expose the showToast method for displaying toast messages
export function useToast() {
  const {addToast} = useContext<ToastContextType>(ToastContext);
  const route = useRoute();
  // display only one toast on each screen
  const id = route.key;

  // wrapper for addToast to pass id into add toast while only exposing other attribute
  function showToasts(title: string, message: string, type: ToastType, duration:number = toastDuration) {
    addToast(id, title, message, type, toastDuration);
  }

  return {showToasts};
}
